import { NgModule } from "@angular/core";

import { SearchModule, IconModule } from "@vowkey/components";
import { VaultFilterServiceAbstraction } from "@vowkey/vault";

import { VaultFilterSharedModule } from "../../individual-vault/vault-filter/shared/vault-filter-shared.module";

import { OrganizationOptionsComponent } from "./components/organization-options.component";
import { VaultFilterComponent } from "./components/vault-filter.component";
import { WebIndividualVaultFilterService } from "./web-individual-vault-filter.service";

@NgModule({
  imports: [VaultFilterSharedModule, SearchModule, IconModule, OrganizationOptionsComponent],
  declarations: [VaultFilterComponent],
  exports: [VaultFilterComponent],
  providers: [
    {
      // Web individual vault includes PAM-gated ("partial") ciphers in the folder filter tree,
      // matching its list; other clients use the base VaultFilterService, which excludes them.
      provide: VaultFilterServiceAbstraction,
      useClass: WebIndividualVaultFilterService,
    },
  ],
})
export class VaultFilterModule {}
